import React from "react";
import className from 'classnames';

const RotSection = ({shouldUseWhiteText, subtitle, title, img, imgWrap, imgProps, flip, children}) => {
  const imgElt = <img src={img} {...imgProps} />

  return <div className={`md:flex pb-10 ${flip ? 'flex-row-reverse' : ''}`}>
    <div className="px-12 pt-10 w-full md:w-1/2 self-center text-center">
      {imgWrap ? <div className="bg-white shadow-faint inline-block p-16" style={{borderRadius: '100%', maxWidth: '60%'}}>
        {imgElt}
      </div> : imgElt}
    </div>
    <div className={`${shouldUseWhiteText ? 'text-white' : 'text-black'} px-8 md:px-10 xl:px-20 self-center w-full md:w-1/2 text-lg`}>
      <p className="uppercase mb-1 tracking-wider">
        {subtitle}
      </p>
      <h2 className={`${shouldUseWhiteText ? 'text-white' : 'text-black'} font-extrabold text-3xl xl:text-4xl mb-3 tracking-tight md:tracking-normal`}>
        {title}<span className="text-primary">.</span>
      </h2>
      {children}
    </div>
  </div>
};

export default RotSection;
